<div class="navbar-container">
  <div class="step" [ngClass]="{'completed': step.Completed, 'active': step.Active }" (click)="setStep(step.Id)"
    *ngFor="let step of NavbarSteps">
    <div class="circle" *ngIf="step.Completed">
      <span class="checkmark">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 12.5L10 16.5L18 8.5" stroke="white" stroke-width="2.8" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>
    </div>
    <div class="circle active-circle" *ngIf="step.Active"></div>
    <div class="circle disable-circle" *ngIf="!step.Active && !step.Completed"></div>

    <span class="label">{{step.Title}}</span>
  </div>
</div>